import { createFileRoute } from '@tanstack/react-router';

import { redirectIfAuthenticated } from '@/app/guards';
import { MagicLinkRequestPage } from '@/features/auth';

export const Route = createFileRoute('/(public)/sign-in-link')({
  beforeLoad: redirectIfAuthenticated,
  component: MagicLinkRequestPage,
});
